import { render, staticRenderFns } from "./FeedbackAttachments.vue?vue&type=template&id=4db64702&scoped=true&"
import script from "./FeedbackAttachments.vue?vue&type=script&lang=js&"
export * from "./FeedbackAttachments.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackAttachments.vue?vue&type=style&index=0&id=4db64702&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db64702",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VCard,VDialog,VIcon,VProgressCircular})
